var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu_holder" },
    [
      _vm.brandLayout !== "generic"
        ? [
            _c("div", { staticClass: "sports-menu" }, [
              _vm.brandKey === "sb"
                ? _c("div", { staticClass: "wrapper navigation" }, [
                    _c(
                      "h3",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToHome()
                          }
                        }
                      },
                      [
                        _c("icon", { attrs: { name: "icon-home" } }),
                        _vm._v("Home\n        ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isLoggedIn
                      ? _c(
                          "h3",
                          {
                            staticClass: "account",
                            class: { active: _vm.dialogMyAccount },
                            on: {
                              click: function($event) {
                                return _vm.toggleMyAccount()
                              }
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "icon-user" }, [
                              _vm._v("account_circle")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("MyAccount.Account")))
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.brandKey === "qcasino"
                ? _c("div", { staticClass: "wrapper navigation" }, [
                    _c(
                      "h3",
                      {
                        on: {
                          click: function($event) {
                            return _vm.toggleMyAccount()
                          }
                        }
                      },
                      [
                        _c("icon", { attrs: { name: "icon-home" } }),
                        _vm._v("Q PROFILE\n        ")
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wrapper sports-az navigation" },
                [
                  _c("site-navigation", {
                    staticClass: "about-us navigation",
                    attrs: { "navigation-section": "ABOUT_US" }
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandLayout === "generic"
        ? [
            _c(
              "div",
              { staticClass: "sports-menu" },
              [
                _c("site-navigation", {
                  staticClass: "about-us navigation",
                  attrs: { "navigation-section": "ABOUT_US" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("app-settings")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82e25478", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82e25478","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/hamburgerMenu.vue
// module id = null
// module chunks = 